import React, { useRef } from "react";
import { useState } from "react";
import { ApiCaller } from "../../config/api/api";
import Recaptcha from "../recapcha/recaptcha";

const ReserveTable = () => {
  const [reserveTableData, setReserveTable] = useState({
    name: "",
    phone: "",
    time: "",
    number_of_persons: "1",
    date: "",
    email: "",
  });

  const [captchaValue, setCaptchaValue] = useState(null);
  const captchaRef = useRef(null);

  const SITE_KEY = "6LfDZEsrAAAAAOU5hgV9_e57bK2BRGVqrPeA_9no";

  const handleChange = (e) => {
    setReserveTable({ ...reserveTableData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaValue) {
      alert("please verify that you are not a robot");
      return;
    }
    try {
      const response = await ApiCaller('reservations/','POST',reserveTableData);
  
      if (response) {
        alert("Thanks, your booking request is waiting to be confirmed.");
  
        setReserveTable({
          name: "",
          phone: "",
          time: "",
          number_of_persons: "1",
          date: "",
          email: "",
        });
  
         setCaptchaValue(null);
        captchaRef.current?.reset();
      } else {
        alert("Failed to make reservation");
      }
        setCaptchaValue(null);
        captchaRef.current?.reset();
    } catch (error) {
      
    }
  };
  return (
    <div className="flex justify-center items-center h-screen lg:h-[80vh] mt-5 lg:m-0 py-4">
      <form
        className="bg-slate-100 p-9 rounded-lg w-full lg:w-2/3"
        onSubmit={handleSubmit}
      >
        <div className="block lg:flex gap-2">
          <div className="w-full">
            <label htmlFor="date" className="text-gray-600 font-bold block">
              Date
            </label>
            <input
              type="date"
              id="date"
              className="border rounded-md w-full p-1"
              onChange={handleChange}
              value={reserveTableData.date}
            />
          </div>
          <div className="w-full">
            <label htmlFor="time" className="text-gray-600 font-bold block">
              Time
            </label>
            <input
              type="time"
              id="time"
              className="border rounded-md w-full p-1"
              onChange={handleChange}
              value={reserveTableData.time}
            />
          </div>
        </div>
        <div className="block lg:flex gap-2 my-2">
          <div className="w-full">
            <label
              htmlFor="number_of_persons"
              className="text-gray-600 font-bold block"
            >
              No of persons
            </label>
            <input
              type="number"
              id="number_of_persons"
              min="1"
              className="border rounded-md w-full p-1"
              onChange={handleChange}
              value={reserveTableData.number_of_persons}
            />
          </div>
          <div className="w-full">
            <label htmlFor="name" className="text-gray-600 font-bold block">
              Name
            </label>
            <input
              id="name"
              className="border rounded-md w-full p-1"
              onChange={handleChange}
              value={reserveTableData.name}
            />
          </div>
        </div>
        <div className="block lg:flex gap-2">
          <div className="w-full">
            <label htmlFor="email" className="text-gray-600 font-bold block">
              Email
            </label>
            <input
              id="email"
              className="border rounded-md w-full p-1"
              value={reserveTableData.email}
              onChange={handleChange}
            />
          </div>
          <div className="w-full">
            <label
              htmlFor="phone"
              className="text-base text-gray-600 font-extrabold block"
            >
              Phone
            </label>
            <input
              type="number"
              id="phone"
              className="border border-black rounded-md w-full p-1"
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, "");
              }}
              onChange={handleChange}
              value={reserveTableData.phone}
            />
          </div>
        </div>
        <div className="my-3">
          <Recaptcha sitekey={SITE_KEY} onVerify={setCaptchaValue} />
        </div>
        <div>
          <button
            type="submit"
            className="bg-amber-400 rounded-full text-xs text-white px-12 py-2"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default ReserveTable;
